import './componenets/side-bar-student-item.css';
import React from 'react';
import {
  SideBarStudentItem,
  StudentSideBarItemType,
} from './componenets/side-bar-student-item';

export interface SideBarStudentModel {
  onClick: (type: StudentSideBarItemType) => void;
  selectedType?: StudentSideBarItemType;
}

export const SideBarStudent: React.FC<SideBarStudentModel> = ({
  onClick,
  selectedType,
}) => {
  return (
    <div style={{ width: '250px', marginLeft: '16px' }}>
      <div className="sidebar-section">
        <h3 className="section-title">מידע אישי</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.PROFILE}
          text={'פרטים אישיים'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.PROFILE}
        />
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">לימודים</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.ACADEMIC}
          text={'תוכניות לימודים'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.ACADEMIC}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.LECTURES}
          text={'מפגשים'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.LECTURES}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.LECTURES_CALENDAR}
          text={'מפגשים קלנדריים'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.LECTURES_CALENDAR}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.EXAMS}
          text={'מבחנים'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.EXAMS}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.ASSIGNMENTS}
          text={'מטלות'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.ASSIGNMENTS}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.EXTERNAL_EXAMS}
          text={'מבחנים חיצוניים'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.EXTERNAL_EXAMS}
        />
      </div>

      <div className="sidebar-section">
        <h3 className="section-title">שירותים</h3>
        <SideBarStudentItem
          type={StudentSideBarItemType.DOCS}
          text={'מסמכים'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.DOCS}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.PAYMENT_SERVICES}
          text={'שרותי תשלום'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.PAYMENT_SERVICES}
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.INSTALLMENTS_CREDIT_CARD}
          text={'הוראות קבע באשראי'}
          onClick={onClick}
          isSelected={
            selectedType === StudentSideBarItemType.INSTALLMENTS_CREDIT_CARD
          }
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.INSTALLMENTS_BANK_TRANSFER}
          text={'הוראות קבע בהעברה בנקאית'}
          onClick={onClick}
          isSelected={
            selectedType === StudentSideBarItemType.INSTALLMENTS_BANK_TRANSFER
          }
        />
        <SideBarStudentItem
          type={StudentSideBarItemType.SCHOLARSHIPS}
          text={'מלגות'}
          onClick={onClick}
          isSelected={selectedType === StudentSideBarItemType.SCHOLARSHIPS}
        />
      </div>
    </div>
  );
};
